<div class="flex-center-all w-100">
  <div class="progress-bar-container  {{ size }}">
    <div class="progress-bar" [style.width.%]="percentage"></div>
  </div>
  <div *ngIf="showValue" class="progress-label mx-3" [class.percentage-completed]="+percentage >= 100">{{ percentage | number:'1.2-2' }}%</div>
</div>
